import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface FlashcardListParams {
    page?: number;
    limit?: number;
    search?: string;
    deck_id?: string;
}

interface deck {
    _id: string;
    title: string;
}

interface Flashcard {
    _id: string;
    title_FC: string;
    type: string;
    createdAt: string;
    deck: deck[];
    flashcard_count: number;
    answer: string;
    image: string;
    sound: string;
}

interface FlashcardListResponse {
    flashcards: Flashcard[];
    count: number;
    deck: any
}

const BASE_URL = `/flash-card`;

const FlashcardService = {
    getFlashcards: (params?: FlashcardListParams): Promise<AxiosResponse<FlashcardListResponse>> => {
        const queryParams = {
            deck_id: params?.deck_id,
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.post(`${BASE_URL}/getFlashCardForAdmin`, queryParams);
    },

    createDeckFlashcardAdmin: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/admin/create`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    importFlashcards: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/admin/import-flashcards`, data);
    },

    getFlashcardById: (flashcard_id: string): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/${flashcard_id}`);
    },

    editDeckFlashcardAdmin: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/admin/edit`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getFile: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/getFile`, data);
    },

    deleteFlashcard: (flashcard_id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/${flashcard_id}`);
    },

    getListFlashCard: (params?: FlashcardListParams): Promise<AxiosResponse<FlashcardListResponse>> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.post(`${BASE_URL}/getListFlashCard`, queryParams);
    },
};

export default FlashcardService;